<template>
  <div v-if="content">
    <p v-if="isReachLength == 'N'">
      {{ fnTrimString(content, numberOfCharLimit) }}
    </p>
    <p v-else>
      <i
        class="las la-plus-square"
        @click="fnSelectRow"
        v-if="rowId != activeRow"
      ></i>
      <i
        class="lar la-minus-square"
        @click="fnCloseExpand"
        v-if="rowId == activeRow"
      ></i>
      {{ fnTrimString(content, numberOfCharLimit) }}
    </p>

    <b-alert
      :show="true"
      variant="light"
      v-if="isReachLength == 'Y' && rowId == activeRow"
      class="mb-0"
    >
      <div class="iq-alert-text">
        <p class="mb-0 fs-900">
          {{ content }}
        </p>
      </div>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: 'WDExpandDetailCell',
  props: ['rowId', 'content', 'activeRow', 'numberOfCharLimit'],
  data() {
    return {
      isReachLength: 'N'
    }
  },
  computed: {},
  methods: {
    fnSelectRow() {
      this.$emit('fnSelectRow')
    },
    fnCloseExpand() {
      this.$emit('fnCloseExpand')
    },
    fnTrimString(str, numberOfChar) {
      if (str.length > numberOfChar) {
        this.isReachLength = 'Y'
        return str.substring(0, numberOfChar) + '...' // Trims to 25 characters and adds "..."
      } else {
        this.isReachLength = 'N'
        return str // Returns the string as is if it's 25 characters or less
      }
    }
  }
}
</script>
